/* eslint no-param-reassign: 0 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { promptChangesMessage, promptChangesLeave } from '../actions/prompt';
import { DEFAULT_PROMPT } from '../constants/promptMessages';
import { TRANSLATION_FILES } from '../constants/translation';

export function checkChanges(Comp, options = {}) {
  class CheckChanges extends Component {
    static propTypes = {
      route: PropTypes.shape({}),
      t: PropTypes.func,
    }
    static contextTypes = {
      store: PropTypes.object,
      router: PropTypes.object,
    }
    constructor(props) {
      super(props);
      this.state = {
        hasChanges: false,
      };
    }
    componentDidMount() {
      this.checkBeforeLeave();
      window.addEventListener('beforeunload', this.checkBeforeClose, false);
    }
    componentWillUnmount() {
      window.removeEventListener('beforeunload', this.checkBeforeClose, false);
    }
    checkBeforeClose = (e) => {
      if (this.state.hasChanges) {
        const msg = 'You have unsaved changes. Do you still want to leave?';
        e.returnValue = msg; // REQUIRED
        if (e.stopPropagation) {
          e.stopPropagation();
          e.preventDefault();
        }
        return msg;
      }
      return true;
    }
    getTranslatedMessage = () => {
      const { t } = this.props;
      let message = DEFAULT_PROMPT;
      if (options.message) {
        message = options.message;
      }
      // Translate the message if t function is available
      if (t) {
        return t(message, { ns: TRANSLATION_FILES.translation });
      }
      return message;
    }
    checkBeforeLeave() {
      this.context.router.setRouteLeaveHook(this.props.route, (nextLocation) => {
        // A leave guard registered by the wrapped component (the Reserve screen's unit hold) asks
        // first and runs its own step before the navigation. It only covers navigation inside the
        // app: a refresh or tab close calls this hook without a location and is left alone.
        const guard = this.leaveGuard;
        if (nextLocation && guard && guard.shouldBlock()) {
          const { store } = this.context;
          const callback = () => {
            this.setState({ hasChanges: false }, async () => {
              try {
                await guard.onConfirm();
              } catch (err) {
                // the guard's step is best effort: the navigation the user confirmed still happens
              }
              store.dispatch(promptChangesLeave(nextLocation));
            });
          };
          store.dispatch(promptChangesMessage({
            header: guard.header(),
            message: guard.message(),
            callback,
          }));
          return false;
        }
        if (this.state.hasChanges) {
          const { store } = this.context;
          const callback = () => {
            this.setState({ hasChanges: false }, () => {
              if (options.callback) {
                options.callback();
              } else {
                store.dispatch(promptChangesLeave(nextLocation));
              }
            });
          };
          const message = this.getTranslatedMessage();
          store.dispatch(promptChangesMessage({ callback, message }));
          return false;
        }
        return true;
      });
    }
    handleOnCheck = (hasChanges = false, callback) => {
      if (hasChanges !== this.state.hasChanges) {
        this.setState({ hasChanges }, () => {
          if (callback) {
            callback(!this.state.hasChanges);
          }
        });
      } else if (callback) {
        callback(!this.state.hasChanges);
      }
    }
    handleHasChanges = () => this.state.hasChanges;
    // handleRegisterLeaveGuard takes { shouldBlock(), header(), message(), onConfirm() } or null.
    // react-router v3 keeps one leave hook per route, so the wrapped component cannot add its own.
    handleRegisterLeaveGuard = (guard) => {
      this.leaveGuard = guard;
    }
    render() {
      return (
        <Comp
          onCheck={this.handleOnCheck}
          checkHasChanges={this.handleHasChanges}
          registerLeaveGuard={this.handleRegisterLeaveGuard}
          {...this.props}
        />
      );
    }
  }

  return withTranslation([TRANSLATION_FILES.translation])(CheckChanges);
}



// WEBPACK FOOTER //
// ./src/utils/checkChanges.jsx